import { BoxWidth } from '@uikit/components/Box/consts';
import ModalCloseIcon from '@uikit/components/Modal/ModalCloseIcon/ModalCloseIcon';
import ModalContent from '@uikit/components/Modal/ModalContent';
import type { ShareModalProps } from './interfaces';
import styles from './ShareModal.module.scss';

const ShareModal = ({ children, handleClose, headline }: ShareModalProps) => {
  return (
    <ModalContent width={BoxWidth.SocialMedium}>
      <ModalCloseIcon onClick={handleClose} />
      <div className={styles.headline}> {headline}</div>
      <div className={styles.shareOptions}>{children}</div>
    </ModalContent>
  );
};

export default ShareModal;
